export const assetTypes = {
    SERVICE_PROTO_FILES: "SERVICE_PROTO_FILES",
    SERVICE_ASSETS: "SERVICE_ASSETS",
    SERVICE_PAGE_COMPONENTS: "SERVICE_PAGE_COMPONENTS",
    SERVICE_GALLERY_IMAGES: "SERVICE_GALLERY_IMAGES",
    ORG_ASSETS: "ORG_ASSETS",
    FEEDBACK: "FEEDBACK",
};

export const fileTypes = {
    demoFiles: "demo_files",
    protoFiles: "proto_files",
};
